<template>
<div class="ui segments">
  <div class="ui segment">
    <div class="ui breadcrumb">
      <router-link :to="{name:'home'}" class="section">Sākums</router-link>
      <span class="divider">/</span>
      <div class="active section">Konta papildināšana</div>
    </div>
  </div>

  <div class="ui segment">
    <!-- show this when user is redirected back to page + submit paysera query data to backend -->
    <div class="ui info icon message">
      <i class="notched circle loading icon"></i>
      <div class="content">
        <div class="header">
          Lūdzu uzgaidiet!
        </div>
        <p>Notiek maksājuma apstrāde...</p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {

  computed: {
    paymentData() {
      return this.$store.state.paymentStore.paymentData
    }
  },

  activated: function() {
    var token = this.$route.params.token;
    var data = { payment_token: token };
    this.$store.dispatch('updatePayment', data).then((response) => {
      this.$router.push({
          name: 'topup-payment', 
          params: {
              payment_id: this.paymentData.trx.id
          }
      });
    }).catch((error) => {
        this.$router.push({
            name: 'topup'
        });
    });
  },
}
</script>


// WEBPACK FOOTER //
// TopUpAccountProcessPage.vue?351f249e